import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['content']

  connect() {
    if (!this.isLoggedIn) {
      this.upvoteElement.disabled = 'disabled'

      this.replyElement.addEventListener('click', e => e.preventDefault())
    }
  }

  get upvoteElement() {
    return this.element.querySelector('input.like')
  }

  get replyElement() {
    return this.element.querySelector('a.reply')
  }

  get isLoggedIn() {
    return document.body.dataset.currentUserId != '0'
  }
}
